// Vibes catalog — fun "scene" templates. Each can change just the background scene
// (keep the user's clothes), or restyle the outfit to match the vibe.
import type { VibeEntry } from "./style-types";

import vibeTiger from "@/assets/vibes/tiger.webp";
import vibeLionWalk from "@/assets/vibes/lion-walk.webp";
import vibeElephantSafari from "@/assets/vibes/elephant-safari.webp";
import vibeWolfSnow from "@/assets/vibes/wolf-snow.webp";
import vibePuppy from "@/assets/vibes/puppy.webp";
import vibeKitten from "@/assets/vibes/kitten.webp";
import vibeBunny from "@/assets/vibes/bunny.webp";
import vibeHorse from "@/assets/vibes/horse.webp";
import vibeSportscar from "@/assets/vibes/sportscar.webp";
import vibeBlackCar from "@/assets/vibes/black-car.webp";
import vibeMotorbike from "@/assets/vibes/motorbike_new.webp";
import vibeVespa from "@/assets/vibes/vespa_new.webp";
import vibeBeach from "@/assets/vibes/beach.webp";
import vibeTropicalIsland from "@/assets/vibes/tropical-island.webp";
import vibeMountain from "@/assets/vibes/mountain.webp";
import vibeNeon from "@/assets/vibes/neon-city.webp";
import vibeCafe from "@/assets/vibes/cafe.webp";
import vibeGarden from "@/assets/vibes/garden.webp";
import vibeSnow from "@/assets/vibes/snow.webp";
import vibeRooftop from "@/assets/vibes/rooftop.webp";
import vibeSantorini from "@/assets/vibes/santorini.webp";
import vibeParis from "@/assets/vibes/paris.webp";
import vibeSakura from "@/assets/vibes/sakura.webp";
import vibeBambooForest from "@/assets/vibes/bamboo-forest.webp";
import vibeAutumn from "@/assets/vibes/autumn.webp";
import vibePanther from "@/assets/vibes/panther.webp";
import vibeSnowyOwl from "@/assets/vibes/snowy-owl.webp";
import vibeDeer from "@/assets/vibes/deer.webp";
import vibeDolphins from "@/assets/vibes/dolphins.webp";
import vibeYacht from "@/assets/vibes/yacht.webp";
import vibePrivateJet from "@/assets/vibes/private-jet.webp";
import vibeClassicCar from "@/assets/vibes/classic-car.webp";
import vibeHotAirBalloon from "@/assets/vibes/hot-air-balloon.webp";
import vibeDubai from "@/assets/vibes/dubai.webp";
import vibeNewYork from "@/assets/vibes/new-york.webp";
import vibeMorocco from "@/assets/vibes/morocco.webp";
import vibeVenice from "@/assets/vibes/venice.webp";
import vibeAurora from "@/assets/vibes/aurora.webp";
import vibeDesert from "@/assets/vibes/desert.webp";
import vibeInfinityPool from "@/assets/vibes/infinity-pool.webp";
import vibeWhiteSuv from "@/assets/vibes/white-suv.webp";
import vibeMuscleCar from "@/assets/vibes/muscle-car.webp";
import vibePinkCadillac from "@/assets/vibes/pink-cadillac.webp";
import vibeJeepDesert from "@/assets/vibes/jeep-desert.webp";
import vibeRedVespa from "@/assets/vibes/red-vespa.webp";
import vibeCybertruck from "@/assets/vibes/cybertruck.webp";
import vibeTajMahal from "@/assets/vibes/taj-mahal.webp";
import vibeKyotoTemple from "@/assets/vibes/kyoto-temple.webp";
import vibeGreekTemple from "@/assets/vibes/greek-temple.webp";
import vibeBaliTemple from "@/assets/vibes/bali-temple.webp";
import vibeLavenderField from "@/assets/vibes/lavender-field.webp";
import vibeStarryNight from "@/assets/vibes/starry-night.webp";
import vibePyramidsGiza from "@/assets/vibes/pyramids-giza.webp";
import vibeGreatWall from "@/assets/vibes/great-wall.webp";
import vibePetra from "@/assets/vibes/petra.webp";
import vibeChristRedeemer from "@/assets/vibes/christ-redeemer.webp";
import vibeMachuPicchu from "@/assets/vibes/machu-picchu.webp";
import vibeColosseum from "@/assets/vibes/colosseum.webp";
import vibeChichenItza from "@/assets/vibes/chichen-itza.webp";
import vibeStudioLambo from "@/assets/vibes/studio-lambo.webp";
import vibeStudioFerrari from "@/assets/vibes/studio-ferrari.webp";
import vibeStudioPorsche from "@/assets/vibes/studio-porsche.webp";
import vibeStudioRolls from "@/assets/vibes/studio-rolls.webp";
import vibeBugatti from "@/assets/vibes/bugatti.webp";
import vibeBmwM from "@/assets/vibes/bmw-m.webp";
import vibeYellowLambo from "@/assets/vibes/yellow-lambo.webp";
import vibeDucati from "@/assets/vibes/ducati.webp";
import vibeRoyalEnfield from "@/assets/vibes/royal-enfield.webp";
import vibeHarley from "@/assets/vibes/harley.webp";
import vibePinkMini from "@/assets/vibes/pink-mini.webp";
import vibePinkJeep from "@/assets/vibes/pink-jeep.webp";
import vibeFloralVespa from "@/assets/vibes/floral-vespa.webp";
import vibeStudioGwagon from "@/assets/vibes/studio-gwagon.webp";
import vibeStudioPinkCar from "@/assets/vibes/studio-pink-car.webp";
import vibeButterflyGarden from "@/assets/vibes/butterfly-garden.webp";
import vibePinkCastle from "@/assets/vibes/pink-castle.webp";
import vibeSwanLake from "@/assets/vibes/swan-lake.webp";
import vibeLanternFestival from "@/assets/vibes/lantern-festival.webp";
import vibeRoseGarden from "@/assets/vibes/rose-garden.webp";
import vibeFlamingo from "@/assets/vibes/flamingo.webp";
import vibeUnicorn from "@/assets/vibes/unicorn.webp";
import vibePomeranian from "@/assets/vibes/pomeranian.webp";
import vibeBabyPanda from "@/assets/vibes/baby-panda.webp";
import vibeMaldives from "@/assets/vibes/maldives.webp";
import vibeGwagonNight from "@/assets/vibes/g-wagon-night.webp";
import vibeTeslaRoadster from "@/assets/vibes/tesla-roadster.webp";
import vibeVintageMustang from "@/assets/vibes/vintage-mustang.webp";
import vibeStudioMclaren from "@/assets/vibes/studio-mclaren.webp";
import vibeStudioMaybach from "@/assets/vibes/studio-maybach.webp";
// Classic cars
import vibeClassicBelair from "@/assets/vibes/classic-belair.webp";
import vibeClassicMustangCream from "@/assets/vibes/classic-mustang-cream.webp";
import vibeClassicJaguar from "@/assets/vibes/classic-jaguar.webp";
import vibeClassicBeetle from "@/assets/vibes/classic-beetle.webp";
// Supercars
import vibeSuperFerrariSf90 from "@/assets/vibes/super-ferrari-sf90.webp";
import vibeSuperLamboBlue from "@/assets/vibes/super-lambo-blue.webp";
import vibeSuperBugattiChiron from "@/assets/vibes/super-bugatti-chiron.webp";
import vibeSuperPorscheGt3 from "@/assets/vibes/super-porsche-gt3.webp";
import vibeSuperAstonMartin from "@/assets/vibes/super-aston-martin.webp";
// Bikes
import vibeBikeKawasakiNinja from "@/assets/vibes/bike-kawasaki-ninja.webp";
import vibeBikeDucatiPanigale from "@/assets/vibes/bike-ducati-panigale.webp";
import vibeBikeHarleyFatboy from "@/assets/vibes/bike-harley-fatboy.webp";
import vibeBikeRoyalEnfieldCafe from "@/assets/vibes/bike-royal-enfield-cafe.webp";
import vibeBikeKtmDuke from "@/assets/vibes/bike-ktm-duke.webp";
// Superhero (fictional)

export const VIBES: VibeEntry[] = [
  // ----- WILD & SAFARI (cinematic) -----
  {
    id: "tiger",
    category: "wild",
    label: "With a Tiger",
    image: vibeTiger,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Standing beside a majestic Bengal tiger in golden grass at dawn.",
    scenePrompt:
      "Place the person standing confidently in tall golden savanna grass at dawn beside a massive majestic Bengal tiger. Cinematic National Geographic photography, dramatic warm sunrise backlight, soft mist, shallow depth of field, awe-inspiring powerful mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in earthy safari wear — olive button-up shirt, beige cargo trousers, brown leather boots — standing confidently in tall golden savanna grass at dawn beside a massive majestic Bengal tiger. Cinematic National Geographic look, dramatic warm sunrise backlight, soft mist, awe-inspiring powerful mood.",
    prompt: "",
  },
  {
    id: "lion-walk",
    category: "wild",
    label: "Walking with a Lion",
    image: vibeLionWalk,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Walking side by side with a huge male lion across the savanna.",
    scenePrompt:
      "Place the person walking calmly side by side with a huge male African lion across a sunlit golden savanna at golden hour. Long shadows, dust kicked up around their feet, cinematic National Geographic editorial photography, dramatic warm light, powerful awe-inspiring mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in cinematic safari attire — neutral linen shirt, fitted khaki trousers, leather walking boots — walking calmly side by side with a huge male African lion across a sunlit golden savanna at golden hour. Long shadows, dust in air, dramatic warm cinematic light.",
    prompt: "",
  },
  {
    id: "elephant-safari",
    category: "wild",
    label: "Elephant Safari",
    image: vibeElephantSafari,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Standing beside a gentle giant elephant at sunset.",
    scenePrompt:
      "Place the person standing beside a massive gentle African elephant in the savanna at sunset, hand reaching toward the elephant's trunk. Warm orange backlight, acacia trees in silhouette, dust particles in the air. Cinematic National Geographic editorial style. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in classic safari wear — beige bush shirt, cargo trousers, sun hat — standing beside a massive gentle African elephant in the savanna at sunset, hand reaching toward the elephant's trunk. Warm orange backlight, acacia silhouettes, cinematic mood.",
    prompt: "",
  },
  {
    id: "wolf-snow",
    category: "wild",
    label: "Wolf in Snow",
    image: vibeWolfSnow,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Crouched beside a majestic grey wolf in a snowy pine forest.",
    scenePrompt:
      "Place the person crouched calmly next to a majestic grey wolf in a snowy pine forest. Soft falling snow, cool blue ambient light with subtle warm rim light, breath visible in the cold air, dramatic atmospheric cinematic mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a warm winter look — black puffer jacket, dark trousers, beanie, snow boots, gloves — crouched calmly next to a majestic grey wolf in a snowy pine forest. Soft falling snow, cool blue light with warm rim light, breath visible, dramatic cinematic mood.",
    prompt: "",
  },

  // ----- CUTE ANIMALS -----
  {
    id: "puppy",
    category: "pets",
    label: "With a Puppy",
    image: vibePuppy,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Hugging a fluffy golden retriever puppy in a sunny park.",
    scenePrompt:
      "Place the person in a bright sunlit park, smiling, holding a fluffy golden retriever puppy in their arms close to their chest. Soft warm natural park lighting, shallow depth of field background, very cute happy mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a soft cream cable-knit sweater and light blue jeans with white sneakers, standing in a bright sunlit park, smiling, holding a fluffy golden retriever puppy in their arms close to their chest. Warm natural light, shallow depth of field, cute happy mood.",
    prompt: "",
  },
  {
    id: "kitten",
    category: "pets",
    label: "With a Kitten",
    image: vibeKitten,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Holding a tiny grey tabby kitten by a sunny window.",
    scenePrompt:
      "Place the person indoors by a sunny window, gently holding a tiny grey tabby kitten close to their chest with both hands. Soft warm window light, cozy indoor home setting. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a cozy oversized beige cardigan over a white tee with soft jeans, standing indoors by a sunny window, gently holding a tiny grey tabby kitten close to their chest. Warm window light, cozy peaceful mood.",
    prompt: "",
  },
  {
    id: "bunny",
    category: "pets",
    label: "With a Bunny",
    image: vibeBunny,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Cuddling a tiny fluffy white bunny.",
    scenePrompt:
      "Place the person indoors in soft golden warm light, cuddling a tiny fluffy white baby bunny close to their chest with both hands. Soft pink flowers visible in the foreground. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a soft pastel oversized knit sweater and cream trousers, indoors in warm golden light, cuddling a tiny fluffy white baby bunny close to their chest. Soft pink flowers nearby.",
    prompt: "",
  },
  {
    id: "horse",
    category: "pets",
    label: "With a Horse",
    image: vibeHorse,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Equestrian moment beside a majestic brown horse.",
    scenePrompt:
      "Place the person standing next to a majestic brown horse on a sunlit ranch, hand resting gently on the horse's neck or muzzle. Warm golden hour backlight, soft dust in the air. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in equestrian-inspired wear: cream knit, fitted brown riding pants, tall brown leather riding boots, standing beside a majestic brown horse on a sunlit ranch with a hand on its neck. Warm golden hour light.",
    prompt: "",
  },

  // ----- VEHICLES -----
  {
    id: "sportscar",
    category: "vehicles",
    label: "With a Red Sportscar",
    image: vibeSportscar,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Leaning on a glossy red sports car.",
    scenePrompt:
      "Place the person leaning casually against the side of a glossy red sports car on a clean dark studio backdrop with dramatic lighting. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a sleek black leather jacket, white tee, slim black jeans and white sneakers, leaning casually against a glossy red sports car on a clean studio backdrop with dramatic lighting.",
    prompt: "",
  },
  {
    id: "black-car",
    category: "vehicles",
    label: "With a Black Supercar",
    image: vibeBlackCar,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Standing in front of a matte black supercar.",
    scenePrompt:
      "Place the person standing in front of the front grille of a glossy matte-black luxury supercar in a clean photo studio. Dramatic moody lighting, headlights softly glowing. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a sharp black blazer, black shirt, black trousers and black derby shoes, standing in front of a matte-black luxury supercar in a clean dark photo studio. Dramatic moody lighting with glowing headlights.",
    prompt: "",
  },
  {
    id: "motorbike",
    category: "vehicles",
    label: "With a Motorbike",
    image: vibeMotorbike,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Standing beside a chrome cruiser motorbike.",
    scenePrompt:
      "Place the person standing next to a chrome cruiser motorbike on an empty desert highway at sunset, warm cinematic golden light. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a black leather biker jacket, white tee, dark distressed jeans and black boots, standing beside a chrome cruiser motorbike on a desert highway at sunset. Warm cinematic light.",
    prompt: "",
  },
  {
    id: "vespa",
    category: "vehicles",
    label: "Italian Vespa",
    image: vibeVespa,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Sunny Italian street with a vintage Vespa.",
    scenePrompt:
      "Place the person seated on a vintage robins-egg blue Vespa scooter on a narrow sunny Italian cobblestone street with terracotta buildings and flower boxes, warm afternoon light. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in classic Italian summer wear: white linen shirt, beige tailored shorts (or breezy cream sundress for women), sunglasses, on a vintage blue Vespa in a sunny Italian alley.",
    prompt: "",
  },

  // ----- TRAVEL / NATURE -----
  {
    id: "beach",
    category: "travel",
    label: "On a Beach",
    image: vibeBeach,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Tropical white-sand beach at golden hour.",
    scenePrompt:
      "Place the person walking along a tropical white-sand beach with turquoise water and palm trees in the background, soft golden-hour lighting. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in breezy beachwear: light linen shirt and shorts (or flowy white sundress for women), barefoot on tropical white sand at golden hour.",
    prompt: "",
  },
  {
    id: "tropical-island",
    category: "travel",
    label: "Tropical Island",
    image: vibeTropicalIsland,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Palm trees, turquoise water, paradise vibes.",
    scenePrompt:
      "Place the person on a tropical paradise beach with white sand, turquoise water and tall leaning palm trees in soft golden hour sunlight. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in tropical resort wear: open linen shirt over a tee with cargo shorts and sandals (or flowy beach maxi dress for women), on a paradise beach with palm trees and turquoise water at golden hour.",
    prompt: "",
  },
  {
    id: "santorini",
    category: "travel",
    label: "Santorini",
    image: vibeSantorini,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Cliffside view of the Aegean Sea.",
    scenePrompt:
      "Place the person on a sunny cliffside terrace overlooking turquoise Aegean Sea with whitewashed Santorini buildings and blue-domed chapels, bright midday light. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in breezy Mediterranean summer wear: crisp white linen shirt and beige shorts (or flowy white sundress), sunglasses, on a Santorini cliffside terrace overlooking the Aegean.",
    prompt: "",
  },
  {
    id: "paris",
    category: "travel",
    label: "Paris / Eiffel",
    image: vibeParis,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "In front of the Eiffel Tower at golden hour.",
    scenePrompt:
      "Place the person standing in front of the iconic Eiffel Tower in Paris at golden hour, soft warm light, tower glowing softly in the background. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in Parisian chic: long brown wool coat over a cream knit, dark jeans, brown loafers, scarf — standing in front of the Eiffel Tower in Paris at golden hour.",
    prompt: "",
  },
  {
    id: "sakura",
    category: "travel",
    label: "Cherry Blossoms",
    image: vibeSakura,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Walking through pink sakura tree tunnel in Japan.",
    scenePrompt:
      "Place the person walking down a path inside a tunnel of cherry blossom trees in full bloom in Japan during spring, soft pink petals falling around them, warm afternoon light. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in soft spring layers — a tailored grey blazer over a knit, dark jeans, scarf, white sneakers — walking through a tunnel of pink cherry blossom trees in Japan with petals falling.",
    prompt: "",
  },
  {
    id: "bamboo-forest",
    category: "travel",
    label: "Bamboo Forest",
    image: vibeBambooForest,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Misty Kyoto bamboo grove path.",
    scenePrompt:
      "Place the person walking down a stone path inside a misty bamboo forest in Kyoto Japan, soft diffused green light filtering through tall bamboo on both sides. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a long black wool coat over a black shirt, dark jeans and black boots, walking down a stone path through a misty Kyoto bamboo forest. Diffused green light.",
    prompt: "",
  },
  {
    id: "mountain",
    category: "nature",
    label: "Mountain Hike",
    image: vibeMountain,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Standing on a misty mountain peak.",
    scenePrompt:
      "Place the person standing on a misty mountain peak with dramatic clouds and pine forests below, cool blue lighting. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in outdoor hiking gear: forest green windbreaker, beige cargo trousers and hiking boots, on a misty mountain peak with dramatic clouds.",
    prompt: "",
  },
  {
    id: "snow",
    category: "nature",
    label: "Snowy Forest",
    image: vibeSnow,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Walking through a sunlit snowy pine forest.",
    scenePrompt:
      "Place the person walking through a snowy pine forest at sunset, golden warm light filtering through the trees, soft snowflakes falling, breath visible in cold air. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in cozy winter wear: cream chunky knit sweater, dark puffy jacket, dark jeans, brown snow boots and a beanie, walking through a sunlit snowy pine forest.",
    prompt: "",
  },
  {
    id: "autumn",
    category: "nature",
    label: "Autumn Leaves",
    image: vibeAutumn,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Walking through golden orange and red maple leaves.",
    scenePrompt:
      "Place the person walking through a vibrant autumn forest with golden orange and red maple leaves on the trees and ground, warm sunlight rays through the trees. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a long charcoal grey wool coat over a black turtleneck, jeans, brown leather boots, sunglasses — walking through an autumn forest with golden and red maple leaves.",
    prompt: "",
  },

  // ----- CITY / LIFESTYLE -----
  {
    id: "neon-city",
    category: "city",
    label: "Neon City",
    image: vibeNeon,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Cyberpunk neon-lit Tokyo street.",
    scenePrompt:
      "Place the person on a rainy neon-lit Tokyo street at night, vibrant pink and blue neon signs reflecting on wet pavement, cinematic cyberpunk vibe. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in techwear: black oversized hoodie, cargo pants, chunky sneakers, on a rainy neon-lit Tokyo street with pink and blue neon reflections.",
    prompt: "",
  },
  {
    id: "rooftop",
    category: "city",
    label: "City Rooftop",
    image: vibeRooftop,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Glamorous penthouse rooftop at dusk.",
    scenePrompt:
      "Place the person on a penthouse rooftop overlooking a sparkling city skyline at dusk, soft cool blue ambient light, glamorous urban vibe, bokeh of city lights. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in glam city evening wear: black tailored suit (or sleek black mini dress for women), polished shoes, on a penthouse rooftop overlooking a glittering city skyline at dusk.",
    prompt: "",
  },
  {
    id: "cafe",
    category: "city",
    label: "Cozy Café",
    image: vibeCafe,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Sipping coffee in a warm Parisian café.",
    scenePrompt:
      "Place the person seated at a small marble table in a warm cozy Parisian café, holding a coffee cup, soft window light, blurred bookshelves behind. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in soft Parisian chic: beige trench coat, white knit, dark slim jeans, brown loafers, seated in a warm Parisian café holding a coffee cup.",
    prompt: "",
  },
  {
    id: "garden",
    category: "nature",
    label: "Flower Garden",
    image: vibeGarden,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Surrounded by blooming spring flowers.",
    scenePrompt:
      "Place the person in a vibrant blooming spring garden surrounded by colorful tulips and cherry blossoms, soft sunlight filtering through petals. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a soft pastel spring outfit (light dress for women, light shirt and chinos for men), in a vibrant blooming spring garden of tulips and cherry blossoms.",
    prompt: "",
  },

  // ----- MORE WILD ANIMALS -----
  {
    id: "panther",
    category: "wild",
    label: "With a Black Panther",
    image: vibePanther,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Resting beside a sleek black panther in a misty jungle.",
    scenePrompt:
      "Place the person standing calmly beside a sleek black panther resting on a stone ledge in a misty jungle at dawn. Dramatic shafts of light through lush green foliage, mysterious cinematic National Geographic mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in dark jungle explorer wear — black fitted shirt, charcoal cargo trousers, black leather boots — standing calmly beside a sleek black panther on a stone ledge in a misty jungle at dawn. Dramatic light shafts, cinematic mysterious mood.",
    prompt: "",
  },
  {
    id: "snowy-owl",
    category: "wild",
    label: "With a Snowy Owl",
    image: vibeSnowyOwl,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Snowy owl perched on the arm in a winter forest.",
    scenePrompt:
      "Place the person in a snowy winter forest with a majestic white snowy owl perched gracefully on their gloved arm. Soft falling snow, ethereal cool blue light, ultra-detailed feathers, magical atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a long charcoal wool coat, cream knit scarf, leather gloves, dark jeans and snow boots, in a snowy pine forest with a majestic white snowy owl perched on their gloved arm. Soft falling snow, ethereal blue light.",
    prompt: "",
  },
  {
    id: "deer",
    category: "wild",
    label: "With a Stag Deer",
    image: vibeDeer,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Quiet moment with a stag in an autumn forest.",
    scenePrompt:
      "Place the person standing quietly near a graceful brown stag deer with antlers in a sunlit autumn forest. Warm golden light filtering through orange maple leaves, soft mist, fairytale National Geographic mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a rust-orange wool coat over a cream knit, brown corduroy trousers and tall leather boots, standing quietly near a graceful brown stag in a sunlit autumn forest with golden maple leaves and soft mist.",
    prompt: "",
  },
  {
    id: "dolphins",
    category: "wild",
    label: "Swimming with Dolphins",
    image: vibeDolphins,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Swimming alongside friendly dolphins in turquoise water.",
    scenePrompt:
      "Place the person swimming gracefully alongside friendly bottlenose dolphins in crystal-clear turquoise tropical ocean. Sun rays beaming through the water, white sand below, paradise underwater atmosphere. Keep the person's face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in sleek swimwear — black shorts for men, a chic one-piece swimsuit for women — swimming gracefully alongside friendly dolphins in crystal-clear turquoise water with sun rays and white sand below.",
    prompt: "",
  },

  // ----- LUXURY VEHICLES & TRAVEL -----
  {
    id: "yacht",
    category: "travel",
    label: "On a Luxury Yacht",
    image: vibeYacht,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Mediterranean yacht life at golden hour.",
    scenePrompt:
      "Place the person on the deck of a sleek glossy white luxury yacht on calm turquoise Mediterranean sea at golden hour, coastal hills in the background. Premium lifestyle vibe. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in upscale yachting wear — crisp white linen shirt, beige tailored shorts, white loafers (or a flowy white maxi dress for women) and sunglasses — on the deck of a sleek white luxury yacht on turquoise Mediterranean sea at golden hour.",
    prompt: "",
  },
  {
    id: "private-jet",
    category: "travel",
    label: "Private Jet",
    image: vibePrivateJet,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Inside a luxurious private jet cabin above the clouds.",
    scenePrompt:
      "Place the person seated in a luxurious private jet cabin with cream leather seats, polished wood and gold trim, large windows showing clouds and sky outside. Soft warm cabin lighting. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in luxury travel wear — tailored beige blazer over a black turtleneck, cream tailored trousers, premium loafers (or a chic camel coat over a silk blouse for women) — seated in a luxurious private jet cabin with cream leather, wood and gold trim above the clouds.",
    prompt: "",
  },
  {
    id: "classic-car",
    category: "vehicles",
    label: "Vintage Convertible",
    image: vibeClassicCar,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Retro 60s convertible on a coastal road at sunset.",
    scenePrompt:
      "Place the person leaning casually against a vintage 1960s cream convertible classic car parked on a coastal road at sunset. Palm trees, warm orange sky, retro nostalgic mood, ultra-detailed chrome reflections. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in retro 60s style — slim white tee, fitted black trousers, leather jacket and loafers (or a polka-dot midi dress and red lipstick for women) — leaning casually against a vintage 1960s cream convertible parked on a coastal road at orange sunset with palm trees.",
    prompt: "",
  },
  {
    id: "hot-air-balloon",
    category: "travel",
    label: "Hot Air Balloon",
    image: vibeHotAirBalloon,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Floating over Cappadocia at sunrise.",
    scenePrompt:
      "Place the person inside the basket of a colorful hot air balloon floating over the rocky landscape of Cappadocia at sunrise. Soft pink and orange sky, dozens of balloons in the distance, dreamy atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in cozy travel wear — cream knit sweater, beige scarf, dark jeans, brown boots — inside the basket of a colorful hot air balloon floating over Cappadocia at sunrise. Pink and orange sky, dozens of balloons in the distance.",
    prompt: "",
  },

  // ----- MORE CITIES & LANDMARKS -----
  {
    id: "dubai",
    category: "city",
    label: "Dubai Skyline",
    image: vibeDubai,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Rooftop views of Burj Khalifa at golden hour.",
    scenePrompt:
      "Place the person on a high rooftop overlooking the Dubai skyline at golden hour with Burj Khalifa towering in the background. Modern luxury skyscrapers, glowing windows, dramatic clouds. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in modern luxe city wear — sleek black blazer, white shirt, slim black trousers (or a sleek black mini dress and heels for women) — on a high rooftop overlooking the Dubai skyline at golden hour with Burj Khalifa in the background.",
    prompt: "",
  },
  {
    id: "new-york",
    category: "city",
    label: "New York City",
    image: vibeNewYork,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Yellow taxis and neon Times Square at night.",
    scenePrompt:
      "Place the person on a New York City Times Square street at night surrounded by vibrant neon billboards and yellow taxi cabs, bustling cinematic atmosphere with motion blur. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in NYC street style — long black wool coat over a hoodie, dark jeans, white sneakers (or a leather jacket, mini skirt and boots for women) — on a Times Square street at night with vibrant neon and yellow taxis.",
    prompt: "",
  },
  {
    id: "morocco",
    category: "travel",
    label: "Marrakech Souk",
    image: vibeMorocco,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Colorful Moroccan market with lanterns and spices.",
    scenePrompt:
      "Place the person walking through a vibrant Marrakech Moroccan souk market with colorful spices in baskets, hanging lanterns, painted ceramics and ornate arches. Warm golden light, exotic atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in earthy bohemian travel wear — beige linen shirt, terracotta trousers, leather sandals (or a flowy maxi dress with embroidery for women) — walking through a vibrant Marrakech souk with colorful spices, lanterns and ornate arches in warm golden light.",
    prompt: "",
  },
  {
    id: "venice",
    category: "travel",
    label: "Venice Canal",
    image: vibeVenice,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Romantic gondola ride at sunset.",
    scenePrompt:
      "Place the person seated in a romantic black gondola on a Venice canal at sunset, historic colorful Italian buildings on both sides, warm reflections in the water, dreamy atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in romantic Italian summer wear — crisp white shirt, beige trousers, leather loafers (or a flowy red dress for women) — seated in a black gondola on a Venice canal at sunset with colorful historic buildings and warm water reflections.",
    prompt: "",
  },

  // ----- NATURE WONDERS -----
  {
    id: "aurora",
    category: "nature",
    label: "Northern Lights",
    image: vibeAurora,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Aurora borealis dancing over Iceland.",
    scenePrompt:
      "Place the person standing on a snowy Iceland landscape gazing up at vibrant green northern lights aurora borealis dancing across the starry sky over snow-capped mountains. Magical cool atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in arctic explorer gear — bright red puffer jacket, dark snow trousers, fur-lined hood, beanie and snow boots — standing on a snowy Iceland landscape gazing at vibrant green northern lights dancing over snowy mountains.",
    prompt: "",
  },
  {
    id: "desert",
    category: "nature",
    label: "Desert Oasis",
    image: vibeDesert,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Golden sand dunes around an oasis at sunset.",
    scenePrompt:
      "Place the person standing on a sand dune overlooking a tranquil desert oasis at sunset, rolling golden dunes, palm trees and a small reflective lake below, warm orange sky. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in flowing desert wear — cream linen shirt, sand-colored trousers, leather sandals and a wrapped scarf (or a flowing cream maxi dress and head scarf for women) — standing on a sand dune overlooking a desert oasis with palm trees at orange sunset.",
    prompt: "",
  },
  {
    id: "infinity-pool",
    category: "nature",
    label: "Infinity Pool",
    image: vibeInfinityPool,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Resort infinity pool overlooking the ocean.",
    scenePrompt:
      "Place the person beside a luxurious modern infinity pool overlooking the ocean at sunset, palm trees, daybeds, premium resort vibe with ultra-detailed water reflections. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in upscale resort wear — open white linen shirt over swim shorts, sandals (or a sleek white bikini with a sheer kaftan for women) — beside a luxurious modern infinity pool overlooking the ocean at sunset with palm trees and daybeds.",
    prompt: "",
  },

  // ----- MORE LUXURY VEHICLES -----
  {
    id: "white-suv",
    category: "vehicles",
    label: "White Luxury SUV",
    image: vibeWhiteSuv,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Leaning on a glossy white luxury SUV on a coastal road at sunset.",
    scenePrompt:
      "Place the person leaning casually beside a glossy white luxury SUV (Range Rover style) parked on a scenic coastal road at golden hour. Ocean and cliffs in the background, warm cinematic light. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in upscale weekend wear — beige cashmere sweater, slim white trousers, brown loafers (or a beige knit, cream wide trousers and sunglasses for women) — leaning casually beside a glossy white luxury SUV on a coastal road at golden hour.",
    prompt: "",
  },
  {
    id: "muscle-car",
    category: "vehicles",
    label: "Muscle Car at Dusk",
    image: vibeMuscleCar,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Black muscle car on a misty mountain road.",
    scenePrompt:
      "Place the person standing beside a matte-black American muscle car (Dodge Challenger style) on a misty mountain switchback road at dusk. Dramatic moody clouds, glowing tail lights, cinematic mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in moody street wear — black bomber jacket, dark hoodie, black jeans, black boots — standing beside a matte-black muscle car on a misty mountain road at dusk with dramatic clouds.",
    prompt: "",
  },
  {
    id: "pink-cadillac",
    category: "vehicles",
    label: "Pink Cadillac Diner",
    image: vibePinkCadillac,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Retro pastel pink Cadillac at a neon American diner.",
    scenePrompt:
      "Place the person leaning on a vintage pastel-pink convertible Cadillac parked beside a glowing neon American diner at night. Pink and blue neon reflections, retro Americana mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in retro 50s Americana — leather jacket, cuffed white tee, blue jeans and white sneakers (or a polka-dot swing dress with red lipstick for women) — leaning on a pink vintage Cadillac at a neon-lit diner at night.",
    prompt: "",
  },
  {
    id: "jeep-desert",
    category: "vehicles",
    label: "Desert Jeep",
    image: vibeJeepDesert,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Off-road jeep on golden sand dunes at sunset.",
    scenePrompt:
      "Place the person standing beside a rugged black off-road jeep parked on a golden sand dune at sunset. Warm orange sky, dust kicked up, dramatic adventurous mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in desert adventure wear — beige cargo shirt, dark cargo pants, leather boots and sunglasses (or a fitted khaki jumpsuit and boots for women) — standing beside a rugged black off-road jeep on a golden sand dune at sunset.",
    prompt: "",
  },
  {
    id: "red-vespa",
    category: "vehicles",
    label: "Red Vespa Roma",
    image: vibeRedVespa,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Cherry red Vespa on a sunny Roman cobblestone street.",
    scenePrompt:
      "Place the person seated on a cherry red vintage Vespa scooter on a sunny Roman cobblestone street with terracotta buildings and hanging flower boxes. Warm afternoon Italian light. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in classic Italian summer style — white button-up shirt, beige tailored shorts, leather loafers, sunglasses (or a flowy red sundress and woven hat for women) — seated on a red Vespa on a sunny Roman cobblestone street.",
    prompt: "",
  },
  {
    id: "cybertruck",
    category: "vehicles",
    label: "Neon EV Garage",
    image: vibeCybertruck,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Futuristic electric truck in a cyberpunk neon garage.",
    scenePrompt:
      "Place the person standing beside a glossy angular electric truck in a futuristic underground garage glowing with magenta and cyan neon lights. Reflective floor, cyberpunk mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in futuristic techwear — black asymmetric jacket, cargo pants, chunky sneakers, accent neon (or a sleek metallic-silver jumpsuit for women) — standing beside an angular electric truck in a magenta and cyan neon-lit cyberpunk garage.",
    prompt: "",
  },

  // ----- TEMPLES & SACRED PLACES -----
  {
    id: "taj-mahal",
    category: "wonders",
    label: "Taj Mahal",
    image: vibeTajMahal,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "In front of the Taj Mahal at sunrise.",
    scenePrompt:
      "Place the person standing in front of the iconic Taj Mahal in Agra India at golden sunrise, soft pink and orange sky, white marble glowing, reflecting pool in front. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in elegant Indo-western wear — ivory kurta with subtle embroidery and beige trousers (or a pastel pink anarkali with dupatta for women) — standing in front of the Taj Mahal at golden sunrise with the reflecting pool behind.",
    prompt: "",
  },
  {
    id: "kyoto-temple",
    category: "wonders",
    label: "Kyoto Torii",
    image: vibeKyotoTemple,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Red torii gate framed by autumn maples in Kyoto.",
    scenePrompt:
      "Place the person standing on stone steps in front of a vibrant red torii gate at a tranquil Kyoto temple framed by glowing orange and red maple leaves with a koi pond at their feet. Soft afternoon light. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in modern Japanese-inspired wear — long charcoal kimono-style coat over a black knit, dark trousers, simple sneakers (or a soft cream haori-cut jacket over a long dress for women) — standing in front of a red torii gate framed by autumn maples in Kyoto.",
    prompt: "",
  },
  {
    id: "greek-temple",
    category: "wonders",
    label: "Greek Parthenon",
    image: vibeGreekTemple,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "By the Parthenon ruins at golden hour.",
    scenePrompt:
      "Place the person standing in front of the ancient Parthenon temple ruins on the Athens Acropolis at golden hour, dramatic warm sunlight on marble columns, blue sky. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in Mediterranean elegance — crisp white linen shirt, cream tailored trousers, leather sandals (or a flowing white grecian-style maxi dress for women) — standing in front of the ancient Parthenon temple ruins at golden hour.",
    prompt: "",
  },
  {
    id: "bali-temple",
    category: "wonders",
    label: "Bali Sea Temple",
    image: vibeBaliTemple,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Tanah Lot sea temple at sunset.",
    scenePrompt:
      "Place the person standing on a rocky shore with the iconic Bali Tanah Lot Hindu sea temple silhouette in the background at orange sunset, dramatic ocean waves crashing. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in tropical island wear — open white linen shirt, beige shorts, sandals (or a flowy off-white maxi dress for women) — standing on a rocky shore with the Bali Tanah Lot sea temple silhouette behind at orange sunset.",
    prompt: "",
  },

  // ----- MORE NATURE WONDERS -----
  {
    id: "lavender-field",
    category: "nature",
    label: "Lavender Field",
    image: vibeLavenderField,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Endless purple lavender rows in Provence.",
    scenePrompt:
      "Place the person walking down a path between rows of vibrant purple lavender in full bloom in Provence France, with a stone farmhouse on the horizon, warm summer light. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in soft Provence summer wear — beige linen shirt, cream trousers, woven hat (or a flowing pastel-purple sundress and straw hat for women) — walking down a path between rows of blooming lavender with a stone farmhouse on the horizon.",
    prompt: "",
  },
  {
    id: "starry-night",
    category: "nature",
    label: "Starry Galaxy",
    image: vibeStarryNight,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Under the Milky Way over a still desert lake.",
    scenePrompt:
      "Place the person standing on the shore of a still desert lake under a vivid Milky Way galaxy night sky, stars reflected in the water, magical cool blue atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in cozy night-sky wear — dark navy oversized hoodie, black joggers, sneakers (or a long black knit cardigan over a dark dress for women) — standing on the shore of a still desert lake under a vivid Milky Way galaxy reflected in the water.",
    prompt: "",
  },

  // ----- 7 WONDERS -----
  {
    id: "pyramids-giza",
    category: "wonders",
    label: "Pyramids of Giza",
    image: vibePyramidsGiza,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "At the Great Pyramids of Giza in golden desert light.",
    scenePrompt:
      "Place the person standing on golden desert sand in front of the iconic Great Pyramids of Giza Egypt at sunrise, warm orange sky, soft heat haze, cinematic travel photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in elegant desert travel wear — beige linen shirt, sand-colored trousers, leather sandals and sunglasses (or a flowing cream maxi dress and woven hat for women) — standing in front of the Great Pyramids of Giza Egypt at sunrise.",
    prompt: "",
  },
  {
    id: "great-wall",
    category: "wonders",
    label: "Great Wall of China",
    image: vibeGreatWall,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "On the Great Wall winding across misty mountains.",
    scenePrompt:
      "Place the person standing on the ancient stone Great Wall of China as it winds across green misty mountains at sunrise, dramatic clouds, cinematic travel photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in modern hiking-chic — olive utility jacket, black trousers, sturdy boots (or a fitted earth-tone jacket and joggers for women) — standing on the ancient stone Great Wall of China across misty mountains at sunrise.",
    prompt: "",
  },
  {
    id: "petra",
    category: "wonders",
    label: "Petra Treasury",
    image: vibePetra,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Before the rose-red Treasury facade of Petra.",
    scenePrompt:
      "Place the person standing in front of the iconic rose-red carved Treasury facade of Petra Jordan, glowing in warm sunlight at the end of a narrow canyon, cinematic travel photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in adventurous travel wear — rust linen shirt, beige cargo trousers, leather boots (or a terracotta wrap dress and woven hat for women) — standing in front of the rose-red Treasury facade of Petra Jordan in warm sunlight.",
    prompt: "",
  },
  {
    id: "christ-redeemer",
    category: "wonders",
    label: "Christ the Redeemer",
    image: vibeChristRedeemer,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Atop Corcovado mountain in Rio de Janeiro.",
    scenePrompt:
      "Place the person standing on the mountaintop platform near the towering Christ the Redeemer statue in Rio de Janeiro, with sweeping views of the city and ocean below at golden hour, soft clouds, cinematic travel photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in tropical-city smart-casual — light blue linen shirt, white trousers, loafers (or a flowing white sundress and sandals for women) — standing on the mountaintop near the Christ the Redeemer statue in Rio at golden hour.",
    prompt: "",
  },
  {
    id: "machu-picchu",
    category: "wonders",
    label: "Machu Picchu",
    image: vibeMachuPicchu,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Ancient Inca ruins in the Andes mist.",
    scenePrompt:
      "Place the person standing at the iconic viewpoint overlooking the ancient Machu Picchu Inca ruins on green Andean mountain peaks with morning mist and dramatic clouds, cinematic travel photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in mountain-explorer wear — earthy puffer vest over a charcoal long-sleeve, dark trekking trousers, hiking boots (or a fitted khaki utility jacket and joggers for women) — standing at the viewpoint overlooking Machu Picchu with mist and clouds.",
    prompt: "",
  },
  {
    id: "colosseum",
    category: "wonders",
    label: "Colosseum Rome",
    image: vibeColosseum,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "In front of the Roman Colosseum at sunset.",
    scenePrompt:
      "Place the person standing in front of the iconic Roman Colosseum amphitheater at golden sunset, warm light glowing on ancient stone, dramatic sky, cinematic travel photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in Italian smart-casual — beige blazer over a white tee, dark jeans, brown loafers (or a beige trench over a black knit and wide trousers for women) — standing in front of the Roman Colosseum at golden sunset.",
    prompt: "",
  },
  {
    id: "chichen-itza",
    category: "wonders",
    label: "Chichen Itza",
    image: vibeChichenItza,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "By the Mayan pyramid El Castillo in Mexico.",
    scenePrompt:
      "Place the person standing on green grass in front of the iconic Mayan stepped pyramid El Castillo at Chichen Itza Mexico, blue sky with white clouds, cinematic travel photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in tropical explorer wear — white linen shirt, beige shorts, leather sandals and sun hat (or a white linen midi dress and woven hat for women) — standing in front of the Mayan pyramid at Chichen Itza Mexico.",
    prompt: "",
  },

  // ----- STUDIO PHOTOGRAPHY (cars) -----
  {
    id: "studio-lambo",
    category: "studio",
    label: "Studio · Lambo",
    image: vibeStudioLambo,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Editorial studio shoot beside a black Lamborghini.",
    scenePrompt:
      "Place the person posing confidently next to a glossy black Lamborghini supercar in a high-end professional photography studio, dramatic moody overhead spotlights on a dark seamless backdrop, glossy reflective floor, premium automotive editorial photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in sleek all-black evening wear — fitted black tee, slim black trousers, black designer sneakers (or a sleek black mini dress and heels for women) — posing confidently next to a glossy black Lamborghini in a moody studio shoot with dramatic spotlights and reflective floor.",
    prompt: "",
  },
  {
    id: "studio-ferrari",
    category: "studio",
    label: "Studio · Ferrari",
    image: vibeStudioFerrari,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Editorial studio shoot beside a red Ferrari.",
    scenePrompt:
      "Place the person posing confidently beside a glossy red Ferrari sports car in a professional photography studio, soft pink-red rim lighting on a light grey seamless backdrop, glossy reflective floor, premium automotive editorial photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in modern luxe — crisp white shirt, slim black trousers, black loafers (or a fitted red mini dress and heels for women) — posing beside a glossy red Ferrari in a bright studio with soft pink rim lighting and reflective floor.",
    prompt: "",
  },
  {
    id: "studio-porsche",
    category: "studio",
    label: "Studio · Porsche",
    image: vibeStudioPorsche,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Vintage studio shoot beside a white Porsche 911.",
    scenePrompt:
      "Place the person posing casually beside a vintage white Porsche 911 classic car in a warm-toned professional photography studio, soft top-down lighting on a beige seamless backdrop, glossy reflective floor, premium retro editorial photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in retro 70s editorial — cream turtleneck, brown corduroy trousers, suede loafers (or a camel knit and high-waisted flared trousers for women) — posing beside a vintage white Porsche 911 in a warm-toned studio with beige backdrop.",
    prompt: "",
  },
  {
    id: "studio-rolls",
    category: "studio",
    label: "Studio · Rolls Royce",
    image: vibeStudioRolls,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Luxury studio shoot beside a matte black Rolls Royce.",
    scenePrompt:
      "Place the person posing elegantly beside a matte black Rolls Royce luxury car in a moody professional photography studio, dramatic side lighting on a black seamless backdrop, glossy reflective floor, ultra-premium automotive editorial photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in elevated formalwear — sharp black tuxedo with bow tie (or a long black evening gown with subtle sparkle for women) — posing elegantly beside a matte black Rolls Royce in a moody luxury studio with dramatic side lighting.",
    prompt: "",
  },

  // ----- MORE LUXURY CARS -----
  {
    id: "bugatti",
    category: "vehicles",
    label: "Blue Bugatti",
    image: vibeBugatti,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Glossy blue Bugatti on a rainy neon city street.",
    scenePrompt:
      "Place the person standing beside a glossy blue Bugatti Chiron hypercar on a rainy neon-lit city street at night. Vivid neon reflections on wet pavement, cinematic moody atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in sleek modern luxe — black tailored blazer over a black tee, slim black trousers, designer sneakers (or a fitted black mini dress and heels for women) — standing beside a glossy blue Bugatti hypercar on a rainy neon-lit city street at night.",
    prompt: "",
  },
  {
    id: "bmw-m",
    category: "vehicles",
    label: "Silver BMW M",
    image: vibeBmwM,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Silver BMW M sedan on a mountain road at sunset.",
    scenePrompt:
      "Place the person leaning casually against a sleek silver BMW M sport sedan parked on a winding mountain road at golden sunset. Warm cinematic light. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in upscale weekend wear — fitted grey knit, dark slim trousers, leather loafers (or a beige trench, white knit and wide trousers for women) — leaning on a silver BMW M sedan on a mountain road at sunset.",
    prompt: "",
  },
  {
    id: "yellow-lambo",
    category: "vehicles",
    label: "Yellow Lamborghini",
    image: vibeYellowLambo,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Bright yellow Lamborghini in a luxury studio.",
    scenePrompt:
      "Place the person posing confidently next to a bright yellow Lamborghini Huracan supercar in a luxury photo studio with reflective floor and dramatic lighting. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in bold modern street-luxe — black biker jacket, white tee, slim black jeans (or a black bodycon mini dress and heels for women) — beside a bright yellow Lamborghini in a luxury studio with dramatic lighting.",
    prompt: "",
  },
  {
    id: "ducati",
    category: "vehicles",
    label: "Red Ducati Bike",
    image: vibeDucati,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Red Ducati sport bike on a mountain race road.",
    scenePrompt:
      "Place the person standing beside a glossy red Ducati Panigale sport bike on a winding mountain race road at golden hour. Cinematic warm light. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in moto-racer wear — red and black leather racing jacket, dark jeans or fitted moto pants, black boots (or a fitted red moto jacket, black jeans and ankle boots for women) — beside a red Ducati sport bike on a mountain race road at golden hour.",
    prompt: "",
  },
  {
    id: "royal-enfield",
    category: "vehicles",
    label: "Royal Enfield",
    image: vibeRoyalEnfield,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Classic Royal Enfield Bullet in the Himalayas.",
    scenePrompt:
      "Place the person standing beside a classic Royal Enfield Bullet 350 motorcycle on a Himalayan mountain road with snowy peaks behind under a clear blue sky. Cinematic adventure mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in rugged Himalayan biker wear — olive utility jacket, dark cargo trousers, brown leather boots, scarf (or a fitted olive jacket, black trousers and boots for women) — standing beside a classic Royal Enfield Bullet on a Himalayan road with snowy peaks.",
    prompt: "",
  },
  {
    id: "harley",
    category: "vehicles",
    label: "Harley Route 66",
    image: vibeHarley,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Black Harley cruiser on Route 66 at sunset.",
    scenePrompt:
      "Place the person standing beside a black Harley Davidson cruiser motorcycle on a Route 66 American highway with desert mesa under a fiery orange sunset. Cinematic Americana mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in classic Americana biker wear — black leather jacket, white tee, dark distressed jeans, black boots, bandana (or a fitted black moto jacket, ripped jeans and ankle boots for women) — beside a black Harley cruiser on Route 66 at sunset.",
    prompt: "",
  },
  {
    id: "pink-mini",
    category: "vehicles",
    label: "Pink Mini Cooper",
    image: vibePinkMini,
    genders: ["women"],
    defaultMode: "outfit",
    description: "Pastel pink Mini convertible on a Malibu coast road.",
    scenePrompt:
      "Place the person beside a pastel pink Mini Cooper convertible parked on a sunny Malibu coastal road with palm trees and the ocean behind. Bright cute girly aesthetic. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in cute summer chic — white crop tee, light denim shorts or a flowy pastel mini dress, white sneakers and oversized sunglasses — beside a pastel pink Mini Cooper convertible on a sunny Malibu coastal road with palm trees.",
    prompt: "",
  },
  {
    id: "pink-jeep",
    category: "vehicles",
    label: "Pink Beach Jeep",
    image: vibePinkJeep,
    genders: ["women"],
    defaultMode: "outfit",
    description: "Pastel pink Jeep on a tropical beach at sunset.",
    scenePrompt:
      "Place the person standing beside a pastel pink Jeep Wrangler parked on a tropical beach with palm trees at sunset. Dreamy warm light, cute aesthetic. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in cute beach chic — flowy white sundress or pastel co-ord set, woven sun hat and sandals — beside a pastel pink Jeep Wrangler on a tropical beach with palm trees at sunset.",
    prompt: "",
  },
  {
    id: "floral-vespa",
    category: "vehicles",
    label: "Floral Vespa",
    image: vibeFloralVespa,
    genders: ["women"],
    defaultMode: "scene",
    description: "Vespa with pink flowers outside a Paris patisserie.",
    scenePrompt:
      "Place the person standing beside a vintage white Vespa scooter decorated with pink flowers outside a Parisian patisserie with pink macarons in the window. Warm afternoon light, dreamy aesthetic. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in romantic Parisian chic — pastel midi dress with puff sleeves, a small handbag, ballet flats or strappy sandals — beside a flower-decorated white Vespa outside a Paris patisserie with pink macarons in the window.",
    prompt: "",
  },

  // ----- MORE STUDIO -----
  {
    id: "studio-gwagon",
    category: "studio",
    label: "Studio · G-Wagon",
    image: vibeStudioGwagon,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Editorial studio shoot beside a white Mercedes G-Wagon.",
    scenePrompt:
      "Place the person posing confidently beside a glossy white Mercedes G-Wagon SUV in a luxury photo studio with soft top-down lighting on a beige seamless backdrop and reflective floor. Premium editorial photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in upscale street-luxe — beige cashmere knit, slim cream trousers, white sneakers (or a beige co-ord set with heels for women) — beside a glossy white Mercedes G-Wagon in a warm-toned luxury studio.",
    prompt: "",
  },
  {
    id: "studio-pink-car",
    category: "studio",
    label: "Studio · Pink Car",
    image: vibeStudioPinkCar,
    genders: ["women"],
    defaultMode: "scene",
    description: "Glossy hot-pink convertible in a pink studio.",
    scenePrompt:
      "Place the person posing playfully beside a glossy hot-pink convertible sports car in a luxury photo studio with soft pink and white spotlights, white seamless backdrop and reflective floor. Premium girly editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in playful pink editorial — fitted pink mini dress or co-ord set with bold pink heels and statement sunglasses — beside a glossy hot-pink convertible in a soft pink luxury photo studio.",
    prompt: "",
  },

  // ----- MORE PETS / WILD (girl-friendly) -----
  {
    id: "pomeranian",
    category: "pets",
    label: "With a Pomeranian",
    image: vibePomeranian,
    genders: ["women"],
    defaultMode: "scene",
    description: "Holding a fluffy white Pomeranian on a pink couch.",
    scenePrompt:
      "Place the person seated on a pink velvet couch in a sunlit room with pink roses, gently holding a fluffy white Pomeranian dog. Soft warm window light, cute girly aesthetic. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in soft girly loungewear — pastel pink knit sweater, white wide trousers and ballet flats — seated on a pink velvet couch in a sunlit room with pink roses, holding a fluffy white Pomeranian.",
    prompt: "",
  },
  {
    id: "baby-panda",
    category: "pets",
    label: "With a Baby Panda",
    image: vibeBabyPanda,
    genders: ["men", "women"],
    defaultMode: "scene",
    description: "Crouched beside a tiny baby panda in a bamboo grove.",
    scenePrompt:
      "Place the person crouched gently beside a tiny adorable baby panda in a sunlit bamboo grove. Soft natural sunlight filtering through bamboo, very cute happy mood. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in soft natural wear — cream knit sweater, beige trousers, white sneakers (or a sage green dress with white sneakers for women) — crouched gently beside a baby panda in a sunlit bamboo grove.",
    prompt: "",
  },
  {
    id: "flamingo",
    category: "wild",
    label: "With Flamingos",
    image: vibeFlamingo,
    genders: ["women"],
    defaultMode: "outfit",
    description: "Standing in turquoise water beside pink flamingos.",
    scenePrompt:
      "Place the person standing barefoot in shallow turquoise tropical water beside graceful pink flamingos at golden hour. Dreamy warm light, soft reflections. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in flowing pink resort wear — a soft pink maxi dress with a thigh-high slit, woven sun hat, layered gold jewellery — standing barefoot in shallow turquoise water beside graceful pink flamingos at golden hour.",
    prompt: "",
  },
  {
    id: "unicorn",
    category: "wild",
    label: "With a Unicorn",
    image: vibeUnicorn,
    genders: ["women"],
    defaultMode: "outfit",
    description: "Beside a magical white unicorn in a misty forest.",
    scenePrompt:
      "Place the person standing gracefully beside a magical white unicorn with a flowing mane in a misty enchanted forest with soft sunbeams and pink flowers. Fairytale atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in fairytale princess wear — flowing pastel-lavender gown with delicate floral embroidery, soft braided hair with flowers — standing gracefully beside a magical white unicorn in a misty enchanted forest with sunbeams.",
    prompt: "",
  },

  // ----- MORE DREAMY SCENES (girl-friendly) -----
  {
    id: "butterfly-garden",
    category: "nature",
    label: "Butterfly Garden",
    image: vibeButterflyGarden,
    genders: ["women"],
    defaultMode: "outfit",
    description: "Surrounded by colorful butterflies in a sunlit garden.",
    scenePrompt:
      "Place the person standing in a magical butterfly garden surrounded by hundreds of colorful butterflies fluttering around blooming pink flowers in soft golden sunlight. Dreamy fairy-tale atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a flowy pastel floral midi dress with puff sleeves, soft natural makeup and loose waves — standing in a magical butterfly garden with hundreds of colorful butterflies and pink flowers in golden sunlight.",
    prompt: "",
  },
  {
    id: "pink-castle",
    category: "wonders",
    label: "Pink Fairytale Castle",
    image: vibePinkCastle,
    genders: ["women"],
    defaultMode: "outfit",
    description: "Romantic pink castle with cherry blossoms.",
    scenePrompt:
      "Place the person standing in front of a romantic pink fairytale castle on a hilltop with pink cherry blossom trees and soft pastel sunset sky. Dreamy disney aesthetic. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a flowing princess ball gown in soft pink with delicate sparkle, hair in a romantic updo — standing in front of a pink fairytale castle on a hilltop with cherry blossoms at pastel sunset.",
    prompt: "",
  },
  {
    id: "swan-lake",
    category: "nature",
    label: "Swan Lake",
    image: vibeSwanLake,
    genders: ["women"],
    defaultMode: "outfit",
    description: "Beside elegant white swans on a misty pink lake.",
    scenePrompt:
      "Place the person standing on a wooden dock beside a calm misty lake with elegant white swans swimming nearby at sunrise, soft pink and gold light. Romantic atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a delicate white tulle ballerina-inspired dress with soft layered skirt, hair in a low bun — standing on a wooden dock beside a misty lake with white swans at pink-gold sunrise.",
    prompt: "",
  },
  {
    id: "lantern-festival",
    category: "travel",
    label: "Sky Lantern Festival",
    image: vibeLanternFestival,
    genders: ["women"],
    defaultMode: "outfit",
    description: "Surrounded by glowing sky lanterns over a river.",
    scenePrompt:
      "Place the person standing on a wooden boat on a calm river surrounded by hundreds of glowing warm orange paper sky lanterns rising into a starry night sky. Magical romantic atmosphere. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a flowing soft-orange or cream gown with delicate embroidery, hair loose with soft waves — standing on a wooden boat on a calm river surrounded by hundreds of glowing sky lanterns rising into the starry night.",
    prompt: "",
  },
  {
    id: "rose-garden",
    category: "nature",
    label: "Pink Rose Garden",
    image: vibeRoseGarden,
    genders: ["women"],
    defaultMode: "outfit",
    description: "Under a stone arch covered in climbing pink roses.",
    scenePrompt:
      "Place the person standing under a stone arch covered in climbing pink roses in a dreamy rose garden in full bloom at golden sunset. Romantic fairytale aesthetic. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in a romantic blush-pink midi dress with floral lace details and delicate gold jewellery — standing under a stone arch covered in climbing pink roses in a blooming rose garden at golden sunset.",
    prompt: "",
  },
  {
    id: "maldives",
    category: "travel",
    label: "Maldives Overwater",
    image: vibeMaldives,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Overwater bungalow on turquoise Maldives water.",
    scenePrompt:
      "Place the person standing on a wooden deck of a luxury Maldives overwater bungalow with crystal turquoise water around and clear blue sky. Premium tropical resort vibe. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in upscale resort wear — open white linen shirt over swim shorts and sandals (or a sleek white bikini under a flowing sheer kaftan and woven hat for women) — on the wooden deck of a Maldives overwater bungalow with turquoise water all around.",
    prompt: "",
  },

  // ----- NEW VEHICLES + STUDIO (added) -----
  {
    id: "g-wagon-night",
    category: "vehicles",
    label: "Matte Black G-Wagon",
    image: vibeGwagonNight,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Standing beside a matte black Mercedes G-Wagon on a neon-lit city street at night.",
    scenePrompt:
      "Place the person leaning casually against the side of a matte black Mercedes-Benz G-Wagon parked on a wet urban city street at night, glowing neon signs reflecting on the paint. Cinematic moody lighting, shallow depth of field, ultra-detailed photoreal editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in luxe streetwear — black bomber jacket, black hoodie, black slim cargo pants and chunky black sneakers (or sleek black leather mini dress with knee-high boots for women) — leaning against a matte black Mercedes-Benz G-Wagon on a wet neon-lit city street at night. Cinematic moody lighting.",
    prompt: "",
  },
  {
    id: "tesla-roadster",
    category: "vehicles",
    label: "White Tesla Roadster",
    image: vibeTeslaRoadster,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Standing beside a pearl white Tesla Roadster on a coastal cliff road at golden hour.",
    scenePrompt:
      "Place the person standing beside a pearl white Tesla Roadster convertible parked on a scenic coastal cliff road at golden hour, ocean waves in the background, warm sunset light. Photoreal editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in chic minimalist coastal wear — crisp white linen shirt, beige tailored trousers and white sneakers (or flowing white midi dress with strappy sandals for women) — beside a pearl white Tesla Roadster on a golden-hour coastal cliff road.",
    prompt: "",
  },
  {
    id: "vintage-mustang",
    category: "vehicles",
    label: "Vintage Red Mustang",
    image: vibeVintageMustang,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Standing beside a cherry red 1967 Mustang outside a classic American diner at dusk.",
    scenePrompt:
      "Place the person standing beside a cherry red 1967 Ford Mustang Fastback parked outside a classic American 1960s diner at dusk, neon diner sign glowing, retro Americana mood, warm street lights. Photoreal editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in retro Americana — white tee tucked into high-waisted blue jeans with a brown leather belt and white sneakers (or a 60s-inspired red polka-dot midi dress with a denim jacket for women) — beside a cherry red vintage Mustang outside a glowing neon diner at dusk.",
    prompt: "",
  },
  {
    id: "studio-mclaren",
    category: "studio",
    label: "Studio · Orange McLaren",
    image: vibeStudioMclaren,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Posed beside a vibrant orange McLaren 720S on a clean white studio backdrop.",
    scenePrompt:
      "Place the person standing confidently beside a vibrant orange McLaren 720S supercar on a seamless white cyclorama studio backdrop, bright clean professional studio lighting, soft floor reflection. Ultra crisp photoreal automotive editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in bold modern streetwear — black graphic tee, black tapered trousers and white sneakers (or a sleek orange-accent crop set with white sneakers for women) — beside a vibrant orange McLaren 720S on a seamless white studio backdrop with soft floor reflection.",
    prompt: "",
  },
  {
    id: "studio-maybach",
    category: "studio",
    label: "Studio · Gold Maybach",
    image: vibeStudioMaybach,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Posed beside a champagne gold Maybach on a moody dark studio backdrop.",
    scenePrompt:
      "Place the person standing beside a champagne gold Mercedes-Maybach S-Class luxury sedan on a dark moody studio backdrop, dramatic rim lighting highlighting the curves, soft floor reflection. Ultra luxurious editorial automotive photography. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in old-money luxury — tailored cream double-breasted suit, silk pocket square and brown leather loafers (or a champagne silk slip gown with delicate gold jewelry for women) — beside a champagne gold Maybach S-Class on a dark moody studio backdrop with dramatic rim lighting.",
    prompt: "",
  },

  // ----- CLASSIC CARS (vintage / retro) -----
  {
    id: "classic-belair",
    category: "classic-cars",
    label: "'57 Bel Air on Route 66",
    image: vibeClassicBelair,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Turquoise '57 Bel Air convertible on a sunny Route 66.",
    scenePrompt:
      "Place the person leaning casually beside a turquoise blue 1957 Chevrolet Bel Air convertible parked on a sunny Route 66 desert highway at golden hour, palm trees and a Route 66 sign in the background, retro 1950s Americana mood, warm cinematic light. Photoreal editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in classic 1950s Americana — pastel turquoise tailored suit and brown loafers (or a high-waisted cream pencil skirt, white blouse, red lipstick and cat-eye sunglasses for women) — beside a turquoise '57 Chevrolet Bel Air on a sunny Route 66 highway at golden hour.",
    prompt: "",
  },
  {
    id: "classic-mustang-cream",
    category: "classic-cars",
    label: "'65 Mustang at Dusk",
    image: vibeClassicMustangCream,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Cream 1965 Mustang convertible on a Joshua-tree desert road.",
    scenePrompt:
      "Place the person sitting on the hood of a cream 1965 Ford Mustang convertible parked on an empty desert highway at dusk, Joshua trees in the background, warm purple and orange sunset sky, retro 1960s muscle car vibe. Photoreal editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in retro 60s casual — black bomber jacket, white tee, dark slim jeans and brown leather boots (or a 60s mod-style mini dress and white go-go boots for women) — sitting on the hood of a cream '65 Mustang convertible in a Joshua-tree desert at dusk.",
    prompt: "",
  },
  {
    id: "classic-jaguar",
    category: "classic-cars",
    label: "'61 Jaguar E-Type",
    image: vibeClassicJaguar,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Silver Jaguar E-Type at a French chateau.",
    scenePrompt:
      "Place the person standing beside a silver 1961 Jaguar E-Type roadster parked outside a European countryside chateau at sunset, ivy-covered stone walls in the background, soft warm light, classic European elegance. Photoreal editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in old-world European elegance — navy double-breasted blazer, white shirt, beige trousers and brown loafers (or a cream silk blouse, high-waisted black trousers and pearl earrings for women) — beside a silver Jaguar E-Type at a French countryside chateau at sunset.",
    prompt: "",
  },
  {
    id: "classic-beetle",
    category: "classic-cars",
    label: "Vintage Beetle",
    image: vibeClassicBeetle,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Matte navy 1969 Beetle on a flowery cobblestone street.",
    scenePrompt:
      "Place the person posing beside a matte navy 1969 Volkswagen Beetle parked on a sunny European cobblestone street with bougainvillea flowers spilling from balconies, warm afternoon light, retro nostalgic mood. Photoreal editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in relaxed retro casual — beige linen shirt, dark cuffed jeans and white sneakers (or a flowy floral midi dress with a denim jacket and sandals for women) — beside a matte navy vintage Beetle on a sunny European cobblestone street.",
    prompt: "",
  },

  // ----- SUPERCARS -----
  {
    id: "super-ferrari-sf90",
    category: "supercars",
    label: "Red Ferrari · Monaco",
    image: vibeSuperFerrariSf90,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Glossy red Ferrari at Monaco harbor at twilight.",
    scenePrompt:
      "Place the person standing beside a glossy red Ferrari supercar parked on a Monaco harbor promenade at twilight, luxury yachts in the background, neon city lights reflecting on the paint, ultra-luxurious cinematic mood. Photoreal automotive editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in jet-set evening wear — sharp black tuxedo jacket, white shirt and black trousers (or a sleek red satin slip dress with stiletto heels for women) — beside a glossy red Ferrari supercar at Monaco harbor at twilight, yachts behind.",
    prompt: "",
  },
  {
    id: "super-lambo-blue",
    category: "supercars",
    label: "Blue Lambo · Tokyo",
    image: vibeSuperLamboBlue,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Metallic blue Lamborghini on a neon-lit Tokyo street.",
    scenePrompt:
      "Place the person leaning on a metallic blue Lamborghini Huracan supercar parked on a wet neon-lit Tokyo street at night, glowing magenta and cyan reflections, cyberpunk energy. Photoreal automotive editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in techwear streetwear — black asymmetric jacket, dark cargo pants and chunky white sneakers (or a black vinyl mini dress with knee-high boots for women) — leaning on a metallic blue Lamborghini on a neon-lit Tokyo street at night.",
    prompt: "",
  },
  {
    id: "super-bugatti-chiron",
    category: "supercars",
    label: "Bugatti · Dubai Skyline",
    image: vibeSuperBugattiChiron,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Black Bugatti Chiron in front of the Dubai skyline.",
    scenePrompt:
      "Place the person standing beside a glossy black Bugatti Chiron hyper car parked in front of the luxury Dubai skyline at sunset, mirror finish reflections, ultra-premium mood. Photoreal automotive editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in modern luxury — fitted black turtleneck, tailored black trousers and minimal black sneakers, gold watch (or a black silk jumpsuit with gold heels and statement earrings for women) — beside a glossy black Bugatti Chiron with the Dubai skyline at sunset.",
    prompt: "",
  },
  {
    id: "super-porsche-gt3",
    category: "supercars",
    label: "Porsche GT3 · Alps",
    image: vibeSuperPorscheGt3,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "White Porsche 911 GT3 RS on an Alpine mountain road.",
    scenePrompt:
      "Place the person standing beside a glossy white Porsche 911 GT3 RS parked on a winding Alpine mountain road at sunrise, snowy peaks in the background, dynamic luxury mood. Photoreal automotive editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in alpine motorsport-luxe — white quilted bomber, black turtleneck, dark slim trousers and white driving sneakers (or a cream cashmere coat over black knit and slim trousers for women) — beside a white Porsche 911 GT3 RS on a winding Alpine road at sunrise.",
    prompt: "",
  },
  {
    id: "super-aston-martin",
    category: "supercars",
    label: "Aston Martin · Estate",
    image: vibeSuperAstonMartin,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Metallic green Aston Martin at an English country estate.",
    scenePrompt:
      "Place the person standing beside a metallic green Aston Martin Vantage supercar parked on the gravel driveway of an English country mansion at dusk, sophisticated James-Bond-inspired mood, warm window light from the manor. Photoreal automotive editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in suave Bond-style sophistication — sharp midnight-blue tuxedo with black bow tie (or an emerald green floor-length silk gown with a slit and diamond drop earrings for women) — beside a metallic green Aston Martin Vantage at an English country mansion at dusk.",
    prompt: "",
  },

  // ----- BIKES (sport + cruiser) -----
  {
    id: "bike-kawasaki-ninja",
    category: "bikes",
    label: "Kawasaki Ninja · Mountain",
    image: vibeBikeKawasakiNinja,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Black Kawasaki Ninja sportbike on a misty mountain switchback.",
    scenePrompt:
      "Place the person sitting on a sleek black Kawasaki Ninja H2 sportbike parked on a misty mountain switchback road at sunrise, dynamic sport mood, warm rim light through the mist. Photoreal motorcycle editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in sport-bike racing wear — black and red leather racing jacket, black moto pants, black gloves and racing boots — sitting on a sleek black Kawasaki Ninja sportbike on a misty mountain road at sunrise.",
    prompt: "",
  },
  {
    id: "bike-ducati-panigale",
    category: "bikes",
    label: "Red Ducati · Garage",
    image: vibeBikeDucatiPanigale,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Glossy red Ducati Panigale in a neon-lit underground garage.",
    scenePrompt:
      "Place the person standing next to a glossy red Ducati Panigale V4 sportbike parked in an urban underground parking garage with magenta and cyan neon strip lighting, dramatic moody atmosphere. Photoreal motorcycle editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in modern moto-streetwear — black leather biker jacket with red accents, black tee, dark moto jeans and black boots — standing next to a glossy red Ducati Panigale in a neon-lit underground garage.",
    prompt: "",
  },
  {
    id: "bike-harley-fatboy",
    category: "bikes",
    label: "Harley · Route 66",
    image: vibeBikeHarleyFatboy,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Chrome Harley Fat Boy cruiser on Route 66 at golden hour.",
    scenePrompt:
      "Place the person sitting on a vintage chrome Harley-Davidson Fat Boy cruiser motorcycle parked on Route 66 desert highway at golden hour, distant red rock mesas in the background, retro Americana biker mood. Photoreal motorcycle editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in classic cruiser-biker Americana — black leather jacket, white tee, dark distressed jeans, black boots and aviator sunglasses (or a black moto jacket, white tank, dark jeans and ankle boots for women) — sitting on a chrome Harley Fat Boy on Route 66 at golden hour.",
    prompt: "",
  },
  {
    id: "bike-royal-enfield-cafe",
    category: "bikes",
    label: "Royal Enfield Café",
    image: vibeBikeRoyalEnfieldCafe,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Royal Enfield café racer outside a vintage Mumbai cafe.",
    scenePrompt:
      "Place the person standing beside a classic Royal Enfield Continental GT cafe racer motorcycle parked outside a vintage cafe at golden hour, warm hanging café lights, retro café-racer vibe. Photoreal motorcycle editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in retro café-racer style — brown leather jacket, white henley, dark slim jeans and brown leather boots (or a brown moto jacket, cream knit, dark jeans and ankle boots for women) — beside a Royal Enfield Continental GT outside a vintage cafe at golden hour.",
    prompt: "",
  },
  {
    id: "bike-ktm-duke",
    category: "bikes",
    label: "KTM Duke · City",
    image: vibeBikeKtmDuke,
    genders: ["men", "women"],
    defaultMode: "outfit",
    description: "Orange KTM Duke streetfighter on a city overpass at sunset.",
    scenePrompt:
      "Place the person sitting on an orange KTM Duke 390 streetfighter motorcycle parked on a city overpass at sunset, urban skyline silhouette in the background, energetic street-rider mood. Photoreal motorcycle editorial. Keep the person's outfit and face exactly as in the source photo.",
    outfitPrompt:
      "Style the person in modern street-rider gear — black hooded moto jacket with orange accents, black slim moto pants, black gloves and black boots — sitting on an orange KTM Duke streetfighter on a city overpass at sunset.",
    prompt: "",
  },
];
